'use client';

import React, { useEffect } from 'react';

const GoogleTagManger = () => {
	const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
	useEffect(() => {
		if (GTM_ID) {
			const script = document.createElement('script');
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`;
			document.head.appendChild(script);

			const scriptInit = document.createElement('script');
			scriptInit.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', '${GTM_ID}');
      `;
			document.head.appendChild(scriptInit);
		} else {
		}
	}, [GTM_ID]);

	return null;
};

export default GoogleTagManger;

export const handleSignupSuccess = () => {
	try {
		if (typeof window !== 'undefined') {
			window.dispatchEvent(new CustomEvent('signup_complete'));
		}
	} catch (error) {}
};

export const handleDepositSuccess = () => {
	try {
		if (typeof window !== 'undefined') {
			window.dispatchEvent(new CustomEvent('deposit_complete'));
		}
	} catch (error) {}
};
